// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadNote, TaskList, NewTaskStore, CompletedTaskStore, QuickLeadDialogStore, Lead } from 'src/stores/LeadStore';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Avatar from '@mui/material/Avatar'
import { styled } from '@mui/material/styles'
import TimelineDot from '@mui/lab/TimelineDot'
import TimelineItem from '@mui/lab/TimelineItem'
import CardHeader from '@mui/material/CardHeader'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import MuiTimeline, { TimelineProps } from '@mui/lab/Timeline'
import { timeSince } from 'src/utils/date-utils';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PerfectScrollbar from 'react-perfect-scrollbar'
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import Divider from '@mui/material/Divider'
import Tooltip from '@mui/material/Tooltip';
import TaskIcon from '@mui/icons-material/Task';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { SelectOption } from 'src/types/common';
import MenuItem from '@mui/material/MenuItem';
import { leadEndpoints } from '../../configs/endpoints';
import { ProblemDetails } from '../../types/ApiErrorResponse';
import LeadDataFormater from '../leads/view/LeadDataFormater';
import DateTimeDisplayWithLabel from '../common/DateTimeDisplayWithLabel';
import Link from '@mui/material/Link';


type Props = {
    record: TaskList

}

// Styled Timeline component
const Timeline = styled(MuiTimeline)<TimelineProps>(({ theme }) => ({
    margin: 0,
    padding: 0,
    marginLeft: theme.spacing(0.75),
    '& .MuiTimelineItem-root': {
        '&:before': {
            display: 'none'
        },
        '&:last-child': {
            minHeight: 60
        }
    }
}))

const TaskDetails = ({ record }: Props) => {
    const [showAddTask, setShowAddTask] = useState(false);
    const [taskValue, setTaskValue] = useState('');
    const [taskAdded, setTaskAdded] = useState(false);
    const hasChanged = CompletedTaskStore.useState(s => s.hasChanged);

    const task = NewTaskStore.useState(s => s);

    const markComplete = async (taskid: string) => {
        await client.post(leadEndpoints.marktaskascomplete.replace('{taskid}', taskid))
            .then(async (response) => {
                if (hasChanged) CompletedTaskStore.update(s => { s.hasChanged = false; })
                if (!hasChanged) CompletedTaskStore.update(s => { s.hasChanged = true; })

                //setShowAddTask(false);
                //setTaskAdded(true);

            }).catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        var errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\'
                        });
                    }
                }
            });
    }


    const viewQuickLead = (lead: Lead) => {
        LeadScreenStore.update(s => { s.selectedLead = lead });
        QuickLeadDialogStore.update(s => { s.quickLeadDialogMode = true })
    };

    return (
        <Box >
            <Box
                sx={{
                    mb: 2,
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Grid container  justifyContent={'left'}>
                    <Grid item xs={12} md={3}>
                        <Typography variant='body2' sx={{ mr: 2, color: 'text.primary' }}>
                            Created {timeSince(record.createdDate)} by {record.createdBy}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        {(record.dueDate != "" || record.dueDate != null) &&
                            <Typography variant='body2' sx={{ mr: 2, color: 'text.primary' }}>
                                <DateTimeDisplayWithLabel value={record.dueDate} format='date' label='Due Date:' />
                            </Typography>
                        }
                    </Grid>
                    <Grid item xs={12} md={3}>
                        {(record.leadId != "" || record.leadId != null) &&
                            <Box>
                                <Typography variant='body2' sx={{ mr: 2, color: 'text.primary' }}>
                                    <Link
                                        sx={{ textDecoration: 'none', fontSize: '0.875rem' }}
                                        underline="hover"
                                        component="button"
                                        variant="caption"
                                        onClick={() => viewQuickLead(record.lead)}
                                    >
                                        Lead: {record.leadName}
                                    </Link>
                                </Typography>
                                
                            </Box>
                            
                        }
                    </Grid>
                    <Grid item xs={12} md={3}>
                        {record.statusName == "Open" && record.currentUserId == record.ownerId &&
                            <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                                <Tooltip title="Mark as complete">
                                    <Button variant="outlined" color="info" startIcon={<TaskIcon />} size="small" onClick={() => markComplete(record.id)} >
                                        Mark as Complete
                                    </Button>
                                </Tooltip>
                            </Box>
                        }
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography sx={{ mr: 2, fontSize: '0.875rem' }}>Details:</Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant='body2' sx={{ mb: 2 }}>
                            {record.details}
                        </Typography>
                    </Grid>
                    
                </Grid>
                
            </Box>
            
            
            
            
            
            

        </Box>
    )


}

export { TaskDetails }

export default TaskDetails;